import * as React from 'react';

// Material UI
import Grid from '@mui/material/Grid2';
import TextField from '@mui/material/TextField';
import { Typography, IconButton } from '@mui/material';
import Button from '@mui/material/Button';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import Divider from '@mui/material/Divider';
import InputAdornment from '@mui/material/InputAdornment';
// Modal
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';

// Estilos 
import { styled } from '@mui/material/styles';

// Icons UI
import CloseIcon from '@mui/icons-material/Close';
import BorderColorIcon from '@mui/icons-material/BorderColor';

import SelectorPersianas from './SelectorPersianas';


const BootstrapDialog = styled(Dialog)(({ theme }) => ({
	'& .MuiDialogContent-root': {
		padding: theme.spacing(2),
	},
	'& .MuiDialogActions-root': {
		padding: theme.spacing(1),
	},
}));

export default function EditPersiana(params) {
	const [direccion, setDireccion] = React.useState('Izquierda');
	let baseReset = {
		tipo: "persiana",
		descripcion: "",
		area: "",
		marca: "",
		cantidad: 1,
		direccion: direccion,
		medida: {
			alto: "",
			ancho: "",
			m2: ""
		},
		precio: {
			m2: "",
			unitario: "",
			vistas: "",
			compartido: "",
			subtotal: "",
			total: "",
		},
		descuento: {
			primero: 0,
			vistas: 0,
			compartido: 0,
		},
		distribuidor: {
			precio: {
				compartido: "",
				subtotal: "",
				total: "",
			},
			descuento: {
				primero: 0,
				compartido: 0,
			},
		}
	}
	const [baseArticulo, setBase] = React.useState(baseReset)
	const [open, setOpen] = React.useState(false);
	const handleOpen = () => { setOpen(true); setBase(params.edit); }
	const handleClose = () => setOpen(false);

	const handleCancel = () => {
		setBase(baseReset)
		handleClose()
	}

	const handleAceptar = () => {
		if (params.tieneStringVacio(baseArticulo)) {
			params.toast.error('Te faltan Datos Generas que agregar.')
			return false
		} else if (params.tieneStringVacio(baseArticulo.medida)) {
			params.toast.error('Te faltan Medidas que agregar.')
			return false
		} else if (params.tieneStringVacio(baseArticulo.precio)) {
			params.toast.error('Te faltan Precios que agregar.')
			return false
		} else if (params.tieneStringVacio(baseArticulo.descuento)) {
			params.toast.error('Te faltan Descuentos que agregar.')
			return false
		}
		// params.addArticle(baseArticulo)
		params.handleEditArticle(params.articleId, baseArticulo)
		// setBase(baseReset)
		handleClose()
	}

	React.useEffect(() => {
		setBase(params.edit)
	}, [setBase])


	// eslint-disable-next-line
	const handleChangeDireccion = (event: SelectChangeEvent) => {
		let tb = baseArticulo
		tb.direccion = event.target.value
		setBase({ ...tb })
		setDireccion(event.target.value);
	};

	const checkValue = (attr) => {
		return !attr || attr === 0 ? 0 : attr
	}
	const checkValue1 = (attr) => {
		return !attr || attr === 0 ? 1 : attr
	}

	const porcent = (part, total) => {
		return total - ((part * total) / 100)
	}

	const roundDecimal = (number) => {
		let total = checkValue(number)
		total = parseFloat(total)
		let redondeado = parseFloat(total.toFixed(2))
		return redondeado;
	}

	const handleChangeDataArticulo = (e) => {
		let tb = baseArticulo
		let val = e.target.value

		tb.precio.unitario = tb.precio.unitario.replace(/,/g, '');

		// Cliente
		tb.precio.compartido = tb.precio.compartido.replace(/,/g, '');
		tb.precio.subtotal = tb.precio.subtotal.replace(/,/g, '');
		tb.precio.total = tb.precio.total.replace(/,/g, '');

		// Distribuidor
		tb.distribuidor.precio.compartido = tb.distribuidor.precio.compartido.replace(/,/g, '');
		tb.distribuidor.precio.subtotal = tb.distribuidor.precio.subtotal.replace(/,/g, '');
		tb.distribuidor.precio.total = tb.distribuidor.precio.total.replace(/,/g, '');

		switch (e.target.id) {
			case "cantidad":
				tb.cantidad = val

				// Cliente
				tb.precio.subtotal = checkValue(tb.precio.unitario) * checkValue(val)
				tb.precio.compartido = porcent(tb.descuento.primero, tb.precio.subtotal)
				tb.precio.total = porcent(tb.descuento.compartido, tb.precio.compartido)

				// Distribuidor
				tb.distribuidor.precio.subtotal = checkValue(tb.precio.unitario) * checkValue(val)
				tb.distribuidor.precio.compartido = porcent(tb.distribuidor.descuento.primero, tb.distribuidor.precio.subtotal)
				tb.distribuidor.precio.total = porcent(tb.distribuidor.descuento.compartido, tb.distribuidor.precio.compartido)
				break;
			case "descripcion":
				tb.descripcion = val;
				break;
			case "marca":
				tb.marca = val;
				break;
			case "area":
				tb.area = val
				break;

			// Medidas
			case "alto":
				tb.medida.alto = val

				let medidam2a = (val < 1 ? 1 : val) * (checkValue(tb.medida.ancho) < 1 ? 1 : checkValue(tb.medida.ancho))
				tb.medida.m2 = medidam2a
				tb.precio.unitario = checkValue(tb.precio.m2) * checkValue(medidam2a)

				// Cliente
				tb.precio.subtotal = (checkValue(tb.precio.m2) * checkValue(medidam2a)) * checkValue(tb.cantidad)
				tb.precio.compartido = porcent(tb.descuento.primero, (checkValue(tb.precio.m2) * checkValue(medidam2a)) * checkValue(tb.cantidad))
				tb.precio.total = porcent(tb.descuento.compartido, tb.precio.compartido)

				// Distribuidor
				tb.distribuidor.precio.subtotal = (checkValue(tb.precio.m2) * checkValue(medidam2a)) * checkValue(tb.cantidad)
				tb.distribuidor.precio.compartido = porcent(tb.distribuidor.descuento.primero, (checkValue(tb.precio.m2) * checkValue(medidam2a)) * checkValue(tb.cantidad))
				tb.distribuidor.precio.total = porcent(tb.distribuidor.descuento.compartido, tb.distribuidor.precio.compartido)

				break;
			case "ancho":
				tb.medida.ancho = val

				let medidam2b = (val < 1 ? 1 : val) * (checkValue(tb.medida.alto) < 1 ? 1 : checkValue(tb.medida.alto))
				tb.medida.m2 = medidam2b
				tb.precio.unitario = checkValue(tb.precio.m2) * checkValue(medidam2b)

				// Cliente
				tb.precio.subtotal = (checkValue(tb.precio.m2) * checkValue(medidam2b)) * checkValue(tb.cantidad)
				tb.precio.compartido = porcent(tb.descuento.primero, (checkValue(tb.precio.m2) * checkValue(medidam2b)) * checkValue(tb.cantidad))
				tb.precio.total = porcent(tb.descuento.compartido, tb.precio.compartido)

				// Distribuidor
				tb.distribuidor.precio.subtotal = (checkValue(tb.precio.m2) * checkValue(medidam2b)) * checkValue(tb.cantidad)
				tb.distribuidor.precio.compartido = porcent(tb.distribuidor.descuento.primero, (checkValue(tb.precio.m2) * checkValue(medidam2b)) * checkValue(tb.cantidad))
				tb.distribuidor.precio.total = porcent(tb.distribuidor.descuento.compartido, tb.distribuidor.precio.compartido)
				break;

			// Precios
			case "pm2":
				tb.precio.m2 = val
				tb.precio.unitario = checkValue(tb.medida.m2) * val

				// Cliente
				tb.precio.subtotal = (val * checkValue(tb.medida.m2)) * checkValue(tb.cantidad)
				tb.precio.compartido = porcent(tb.descuento.primero, (val * checkValue(tb.medida.m2)) * checkValue(tb.cantidad))
				tb.precio.total = porcent(tb.descuento.compartido, tb.precio.compartido)

				// Distribuidor
				tb.distribuidor.precio.subtotal = (val * checkValue(tb.medida.m2)) * checkValue(tb.cantidad)
				tb.distribuidor.precio.compartido = porcent(tb.distribuidor.descuento.primero, (val * checkValue(tb.medida.m2)) * checkValue(tb.cantidad))
				tb.distribuidor.precio.total = porcent(tb.distribuidor.descuento.compartido, tb.distribuidor.precio.compartido)
				break;

			case "descuentouno":
				tb.descuento.primero = val

				tb.precio.compartido = porcent(val, tb.precio.subtotal)

				tb.precio.total = porcent(tb.descuento.compartido, tb.precio.compartido)
				break;

			case "descuentoCombinado":
				tb.descuento.compartido = val

				tb.precio.total = porcent(val, tb.precio.compartido)
				break;

			// Distribuidor
			case "superman":
				tb.distribuidor.descuento.primero = val

				tb.distribuidor.precio.compartido = porcent(val, tb.distribuidor.precio.subtotal)

				tb.distribuidor.precio.total = porcent(tb.distribuidor.descuento.compartido, tb.distribuidor.precio.compartido)
				break;
			case "batman":
				tb.distribuidor.descuento.compartido = val

				tb.distribuidor.precio.total = porcent(val, tb.distribuidor.precio.compartido)
				break;



			default:
				alert("as")
				break;
		}

		tb.medida.m2 = parseFloat(tb.medida.m2) || 0
		tb.precio.unitario = roundDecimal(tb.precio.unitario).toLocaleString('en-US')
		tb.precio.compartido = roundDecimal(tb.precio.compartido).toLocaleString('en-US')
		tb.precio.subtotal = roundDecimal(tb.precio.subtotal).toLocaleString('en-US')
		tb.precio.vistas = roundDecimal(tb.precio.vistas)
		tb.precio.total = roundDecimal(tb.precio.total).toLocaleString('en-US')

		tb.distribuidor.precio.subtotal = roundDecimal(tb.distribuidor.precio.subtotal).toLocaleString('en-US')
		tb.distribuidor.precio.compartido = roundDecimal(tb.distribuidor.precio.compartido).toLocaleString('en-US')
		tb.distribuidor.precio.total = roundDecimal(tb.distribuidor.precio.total).toLocaleString('en-US')


		setBase({ ...tb })
	}

	const [seleccion, setSeleccion] = React.useState("");
	React.useEffect(() => {
		let tb = baseArticulo
		tb.descripcion = "Persiana " + seleccion;
		setBase({ ...tb })
	}, [seleccion, setSeleccion])



	return (
		<div>
			<IconButton onClick={handleOpen} color="blueRA" aria-label="add to shopping cart">
				<BorderColorIcon />
			</IconButton>
			{/* <Button color={"ochre"} variant="outlined" onClick={handleOpen} startIcon={params.icon}>{params.textbtn}</Button> */}
			<BootstrapDialog
				fullScreen
				// maxWidth='sm'
				open={open}
				onClose={handleClose}
			>
				<DialogTitle>Editar Persiana</DialogTitle>
				<IconButton
					aria-label="close"
					onClick={handleClose}
					sx={(theme) => ({
						position: 'absolute',
						right: 8,
						top: 8,
						color: theme.palette.grey[500],
					})}
				>
					<CloseIcon />
				</IconButton>
				<DialogContent dividers className='barscroll' style={{ height: '80vh', overflow: 'hidden', padding: 0 }}>
					<form noValidate autoComplete="off" style={{ height: '100%' }}>
						<Grid container spacing={{ xs: 2, md: 0 }} rowSpacing={2} columns={{ xs: 8, sm: 10, md: 12 }} style={{ height: '100%', overflowY: 'auto', }}>
							<Grid size={{ xs: 8, sm: 10, md: 7 }}
								style={{
									minHeight: '100%',
									overflowY: 'auto',
									padding: '30px',

								}}
							>
								<Grid container spacing={{ xs: 2, md: 2 }} rowSpacing={2} columns={{ xs: 4, sm: 10, md: 12 }} className="mb-10">
									{/* Cantidad */}
									<Grid size={{ xs: 4, sm: 5, md: 2 }}>
										<TextField
											fullWidth
											id="cantidad"
											label="Cantidad"
											variant="outlined"
											type='number'
											color={"blueRA"}
											size="small"
											inputProps={{ min: 1 }}
											value={baseArticulo.cantidad}
											onChange={handleChangeDataArticulo}
										/>
									</Grid>

									{/* Marca */}
									<Grid size={{ xs: 4, sm: 5, md: 3 }} >
										<TextField
											fullWidth
											id="marca"
											label="Marca"
											variant="outlined"
											type='text'
											color={"blueRA"}
											defaultValue={"AB"}
											size="small"
											value={baseArticulo.marca}
											onChange={handleChangeDataArticulo}
										/>
									</Grid>
									{/* Area */}
									<Grid size={{ xs: 4, sm: 5, md: 4 }} >
										<TextField
											fullWidth
											id="area"
											label="Area"
											variant="outlined"
											type='text'
											color={"blueRA"}
											size="small"
											value={baseArticulo.area}
											onChange={handleChangeDataArticulo}
										/>
									</Grid>
									{/* Direccion */}
									<Grid size={{ xs: 4, sm: 5, md: 3 }}>
										<FormControl fullWidth>
											<InputLabel id="demo-simple-select-label" shrink>Direccion</InputLabel>
											<Select
												labelId="demo-simple-select-label"
												id="direccionControl"
												label="Direccion"
												size="small"
												value={direccion}
												onChange={handleChangeDireccion}
											>
												<MenuItem value={"Izquierda"}>Izquierda</MenuItem>
												<MenuItem value={"Derecha"}>Derecha</MenuItem>
											</Select>
										</FormControl>
									</Grid>
									{/* Descripcion */}
									<Grid size={{ xs: 4, sm: 5, md: 12 }}>
										<SelectorPersianas onChange={setSeleccion} />
									</Grid>
									<Grid size={{ xs: 4, sm: 5, md: 12 }}>
										<TextField
											fullWidth
											id="descripcion"
											label="Nombre"
											variant="outlined"
											type='text'
											color={"blueRA"}
											size="small"
											value={baseArticulo.descripcion}
											onChange={handleChangeDataArticulo}
										/>
									</Grid>
									<Grid size={{ xs: 4, sm: 10, md: 12 }} >
										<Divider className='my-2' />
									</Grid>
									{/* Ancho */}
									<Grid size={{ xs: 4, sm: 5, md: 3 }} >
										<TextField
											fullWidth
											id="ancho"
											label="Ancho"
											variant="outlined"
											type='number'
											color={"blueRA"}
											size="small"
											slotProps={{
												input: {
													endAdornment: <InputAdornment position="end">m</InputAdornment>,
												},
											}}
											value={baseArticulo.medida.ancho}
											onChange={handleChangeDataArticulo}
										/>
									</Grid>
									{/* Alto */}
									<Grid size={{ xs: 4, sm: 5, md: 3 }} >
										<TextField
											fullWidth
											id="alto"
											label="Alto"
											variant="outlined"
											type='number'
											color={"blueRA"}
											size="small"
											slotProps={{
												input: {
													endAdornment: <InputAdornment position="end">m</InputAdornment>,
												},
											}}
											value={baseArticulo.medida.alto}
											onChange={handleChangeDataArticulo}
										/>
									</Grid>
									{/* Resultado Metros Cuadrados */}
									<Grid size={{ xs: 4, sm: 5, md: 6 }} className="flex justify-center items-center">
										<Typography variant='span' className='mr-3'>Metros Cuadrados: </Typography>
										<Typography variant='h6' color='ochre'>{baseArticulo.medida.m2 ? baseArticulo.medida.m2.toFixed(2) : 0}m<sup>2</sup></Typography>
									</Grid>
									<Grid size={{ xs: 4, sm: 10, md: 12 }} >
										<Divider className='my-2' />
									</Grid>
									{/* Precio Metros Cuadrados */}
									<Grid size={{ xs: 4, sm: 5, md: 6 }} >
										<TextField
											fullWidth
											id="pm2"
											label="Metros Cuadrados"
											variant="outlined"
											type='text'
											color={"blueRA"}
											size="small"
											value={baseArticulo.precio.m2}
											onChange={handleChangeDataArticulo}
											slotProps={{
												input: {
													startAdornment: <InputAdornment position="start">$</InputAdornment>,
												},
											}}
										/>
									</Grid>
									{/* Precio Unitario */}
									<Grid size={{ xs: 4, sm: 5, md: 6 }} className="flex justify-center items-center">
										<Typography variant='span' className='mr-3'>Precio Unitario: </Typography>
										<Typography variant='h6' color='ochre'>${baseArticulo.precio.unitario ? baseArticulo.precio.unitario : 0}</Typography>
									</Grid>


									<Grid size={{ xs: 4, sm: 10, md: 12 }} >
										<Divider className='my-2' />
									</Grid>
									<Grid size={{ xs: 4, sm: 5, md: 12 }} className="flex justify-center items-center">
										<Typography variant='span' className='mr-3'>SubTotal: </Typography>
										<Typography variant='h6' color='ochre'>${baseArticulo.precio.subtotal ? baseArticulo.precio.subtotal : 0}</Typography>
									</Grid>
									<Grid size={{ xs: 4, sm: 10, md: 12 }} >
										<Divider className='my-2' />
									</Grid>

									<Grid size={{ xs: 4, sm: 10, md: 12 }} >
										<Typography color={"ochre"} variant='h6' className='ml-4'>Descuentos Cliente:</Typography>
									</Grid>
									{/* Subtotal */}
									{/* Descuento General */}
									<Grid size={{ xs: 4, sm: 5, md: 3 }} >
										<TextField
											fullWidth
											id="descuentouno"
											label="Descuento"
											variant="outlined"
											type='number'
											color={"blueRA"}
											size="small"
											value={baseArticulo.descuento.primero}
											onChange={handleChangeDataArticulo}
											slotProps={{
												input: {
													endAdornment: <InputAdornment position="end">%</InputAdornment>,
												},
											}}
										/>
									</Grid>
									<Grid size={{ xs: 4, sm: 5, md: 6 }} className="flex justify-center items-center">
										<Typography variant='span' className='mr-3'>Compartido: </Typography>
										<Typography variant='h6' color='ochre'>${baseArticulo.precio.compartido ? baseArticulo.precio.compartido : 0}</Typography>
									</Grid>
									<Grid size={{ xs: 4, sm: 5, md: 3 }} >
										<TextField
											fullWidth
											id="descuentoCombinado"
											label="Descuento Adicional"
											variant="outlined"
											type='number'
											color={"blueRA"}
											size="small"
											value={baseArticulo.descuento.compartido}
											onChange={handleChangeDataArticulo}
											slotProps={{
												input: {
													endAdornment: <InputAdornment position="end">%</InputAdornment>,
												},
											}}
										/>
									</Grid>

									<Grid size={{ xs: 4, sm: 10, md: 12 }} >
										<Divider className='my-2' />
									</Grid>

									<Grid size={{ xs: 4, sm: 10, md: 12 }} >
										<Typography color={"ochre"} variant='h6' className='ml-4'>Descuentos Distribuidor:</Typography>
									</Grid>

									{/* Descuento General */}
									<Grid size={{ xs: 4, sm: 5, md: 3 }} >
										<TextField
											fullWidth
											id="superman"
											label="Descuento"
											variant="outlined"
											type='number'
											color={"blueRA"}
											size="small"
											value={baseArticulo.distribuidor.descuento.primero}
											onChange={handleChangeDataArticulo}
											slotProps={{
												input: {
													endAdornment: <InputAdornment position="end">%</InputAdornment>,
												},
											}}
										/>
									</Grid>
									<Grid size={{ xs: 4, sm: 5, md: 6 }} className="flex justify-center items-center">
										<Typography variant='span' className='mr-3'>Compartido: </Typography>
										<Typography variant='h6' color='ochre'>${baseArticulo.distribuidor.precio.compartido ? baseArticulo.distribuidor.precio.compartido : 0}</Typography>
									</Grid>
									<Grid size={{ xs: 4, sm: 5, md: 3 }} >
										<TextField
											fullWidth
											id="batman"
											label="Descuento Adicional"
											variant="outlined"
											type='number'
											color={"blueRA"}
											size="small"
											value={baseArticulo.distribuidor.descuento.compartido}
											onChange={handleChangeDataArticulo}
											slotProps={{
												input: {
													endAdornment: <InputAdornment position="end">%</InputAdornment>,
												},
											}}
										/>
									</Grid>


								</Grid>

							</Grid>

							{/* Lado Derecho */}
							<Grid size={{ xs: 8, sm: 10, md: 5 }}
								style={{
									paddingTop: "10px",
									paddingBottom: "10px",
									overflowY: 'auto',
									minHeight: '100%',
									// position: 'sticky',
									// top: 0,
									// height: '100%',
									// zIndex: 1,
									backgroundColor: "#eaeaea10"
								}}
							>
								<Grid container spacing={{ xs: 2, md: 2 }} rowSpacing={2} columns={{ xs: 12, sm: 12, md: 12 }}>
									<Grid size={{ xs: 12, sm: 12, md: 12 }}>
										<Typography variant='h5' className='text-center'>Resumen Costos</Typography>
									</Grid>
									<Grid size={{ xs: 12, sm: 12, md: 12 }} >
										<Divider className='my-0' />
									</Grid>
									<Grid size={{ xs: 2, sm: 2, md: 2 }} className="text-center" >
										<b>{baseArticulo.cantidad}</b>
									</Grid>
									<Grid size={{ xs: 10, sm: 10, md: 10 }} >
										{baseArticulo.descripcion}
									</Grid>

									<Grid size={{ xs: 12, sm: 12, md: 12 }} >
										<Divider className='my-0' />
									</Grid>

									<Grid size={{ xs: 12, sm: 12, md: 12 }} >
										<Grid container spacing={{ xs: 1, md: 1 }} rowSpacing={1} columns={{ xs: 12, sm: 12, md: 12 }}>
											<Grid size={{ xs: 2, sm: 2, md: 2 }}></Grid>
											<Grid size={{ xs: 4, sm: 4, md: 4 }}>
												<Typography>Subtotal:</Typography>
											</Grid>
											<Grid size={{ xs: 6, sm: 6, md: 6 }}>
												<Typography><b>${baseArticulo.precio.subtotal}</b></Typography>
											</Grid>
											<Grid size={{ xs: 12, sm: 12, md: 12 }} >
												<Divider className='my-0' />
											</Grid>

											<Grid size={{ xs: 12, sm: 12, md: 1 }}></Grid>
											<Grid size={{ xs: 4, sm: 10, md: 5 }} >
												<Typography color='ochre'>Cliente</Typography>
											</Grid>
											<Grid size={{ xs: 4, sm: 10, md: 6 }} >
												<Typography color='ochre'>Distribuidor</Typography>
											</Grid>

											<Grid size={{ xs: 4, sm: 10, md: 1 }}></Grid>
											<Grid size={{ xs: 4, sm: 10, md: 5 }} >
												<Typography>Descuento:</Typography>
												<Typography><b>{baseArticulo.descuento.primero}%</b></Typography>
											</Grid>
											<Grid size={{ xs: 4, sm: 10, md: 6 }} >
												<Typography>Descuento:</Typography>
												<Typography><b>{baseArticulo.distribuidor.descuento.primero}%</b></Typography>
											</Grid>

											<Grid size={{ xs: 4, sm: 10, md: 1 }}></Grid>
											<Grid size={{ xs: 4, sm: 10, md: 5 }} >
												<Typography>Subtotal:</Typography>
												<Typography><b>${baseArticulo.precio.compartido}</b></Typography>
											</Grid>
											<Grid size={{ xs: 4, sm: 10, md: 6 }} >
												<Typography>Subtotal:</Typography>
												<Typography><b>${baseArticulo.distribuidor.precio.compartido}</b></Typography>
											</Grid>

											<Grid size={{ xs: 4, sm: 10, md: 1 }}></Grid>
											<Grid size={{ xs: 4, sm: 10, md: 5 }} >
												<Typography>Descuento Ad:</Typography>
												<Typography><b>{baseArticulo.descuento.compartido}%</b></Typography>
											</Grid>
											<Grid size={{ xs: 4, sm: 10, md: 6 }} >
												<Typography>Descuento Ad:</Typography>
												<Typography><b>{baseArticulo.distribuidor.descuento.compartido}%</b></Typography>
											</Grid>

											<Grid size={{ xs: 4, sm: 10, md: 1 }}></Grid>
											<Grid size={{ xs: 4, sm: 10, md: 5 }} >
												<div className='flex items-center'>
													<Typography variant='p' className='mr-2'>Total:</Typography>
													<Typography variant='h6' color='ochre'><b>${baseArticulo.precio.total}</b></Typography>
												</div>
											</Grid>
											<Grid size={{ xs: 4, sm: 10, md: 6 }} >
												<div className='flex items-center'>
													<Typography variant='p' className='mr-2'>Total:</Typography>
													<Typography variant='h6' color='ochre'><b>${baseArticulo.distribuidor.precio.total}</b></Typography>
												</div>
											</Grid>


										</Grid>
									</Grid>
									<Grid size={{ xs: 4, sm: 10, md: 12 }} >
										<Divider className='my-0' />
									</Grid>

									<Grid size={{ xs: 4, sm: 10, md: 12 }} className="flex justify-center mt-2">
										<div>
											<Button className='mr-5' color='ochre' variant="contained" onClick={handleAceptar}>Aceptar</Button>
											<Button color='error' variant="outlined" onClick={handleCancel}>Cancelar</Button>
										</div>
									</Grid>
								</Grid>
							</Grid>

						</Grid>
					</form>
				</DialogContent>
			</BootstrapDialog>
		</div>
	);
}
